import React from "react";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import "../utils/myMealsCSS.css";

FutureOrderDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default function FutureOrderDialog(props) {
  return (
    <Dialog open={props.isDialogOpen} onClose={props.onClick}>
      <DialogContent>
        <DialogContentText>
          <Typography variant="h3" color="primary">
            {props.text}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClick} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
